var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Header'),_c('v-main',[_c('v-divider'),_c('Calculator')],1),_c('v-divider',{staticClass:"pb-6 hidden-md-and-up"}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }